import { render, staticRenderFns } from "./editBranch.vue?vue&type=template&id=3b2bc642&scoped=true"
import script from "./editBranch.vue?vue&type=script&lang=js"
export * from "./editBranch.vue?vue&type=script&lang=js"
import style0 from "./editBranch.vue?vue&type=style&index=0&id=3b2bc642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2bc642",
  null
  
)

export default component.exports